module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_feature_1-c63403adf1ca6dae3e2dfb60e9824640.jpg";